export const selectEasterEggCode = (state) => state.easterEgg.code; 
export const selectEasterEggDisplay = (state) => state.easterEgg.display; 